import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_SHIPPING_ADDRESS,
  CART_SAVE_PAYMENT_METHOD,
  CART_CLEAR_ITEMS,
} from "../constants/cartConstants";

// Utility function to calculate totals
const calculateTotals = (cartItems) => {
  const totalItemCount = cartItems.reduce((sum, item) => sum + item.qty, 0);
  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.qty * item.price,
    0
  );
  return { totalItemCount, totalPrice };
};

export const cartReducer = (
  state = {
    cartItems: [],
    shippingAddress: {},
    totalItemCount: 0,
    totalPrice: 0,
  },
  action
) => {
  switch (action.type) {
    case CART_ADD_ITEM: {
      const item = action.payload;
      // const existItem = state.cartItems.find((x) => x.product === item.product);

      // const updatedCartItems = existItem
      //   ? state.cartItems.map((x) =>
      //       x.product === existItem.product ? { ...x, qty: x.qty + 1 } : x
      //     )
      //   : [...state.cartItems, item];

      // const { totalItemCount, totalPrice } = calculateTotals(updatedCartItems);

      return {
        ...state,
        cartItems: item,
        // totalItemCount,
        // totalPrice,
      };
    }
    case CART_REMOVE_ITEM: {
      const updatedCartItems = state.cartItems.filter(
        (x) => x.product !== action.payload
      );
      const { totalItemCount, totalPrice } = calculateTotals(updatedCartItems);

      return {
        ...state,
        cartItems: updatedCartItems,
        totalItemCount,
        totalPrice,
      };
    }
    case CART_SAVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.payload,
      };
    case CART_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      };
    case CART_CLEAR_ITEMS:
      return {
        ...state,
        cartItems: [],
        totalItemCount: 0,
        totalPrice: 0,
      };
    default:
      return state;
  }
};
